// Auto generated file, do not manually modify!
// com.hotpads.maintenancetracker.web.users.task.handler.MaintenanceTrackerTaskUserWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  MaintenanceTrackerTaskUserWebApiHandler_create,
  MaintenanceTrackerTaskUserWebApiHandler_delete,
  MaintenanceTrackerTaskUserWebApiHandler_details,
  MaintenanceTrackerTaskUserWebApiHandler_details_Path,
  MaintenanceTrackerTaskUserWebApiHandler_update,
  MaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted,
  MaintenanceTrackerTaskUserWebApiHandler_updateStatus,
} from '@zg-rentals/ts-maintenance-tracker-client';

import type {
  MaintenanceCreateTaskRequestDto,
  MaintenanceCreateTaskResponseDto,
  MaintenanceTaskStatus,
  MaintenanceTrackerTaskDetailsResponseDto,
  MaintenanceUpdateTaskRequestDto,
  MaintenanceUpdateTaskResponseDto,
} from '@zg-rentals/ts-maintenance-tracker-client';

interface DeleteParams {
  maintenanceTaskId: string;
}
interface DetailsParams {
  maintenanceTaskId: string;
}
interface UpdateDateCompletedParams {
  completedTimestampMs: number;
  maintenanceTaskId: string;
}
interface UpdateStatusParams {
  maintenanceTaskId: string;
  status: MaintenanceTaskStatus;
}

export interface MaintenanceTrackerTaskUserWebApiHandler_create_Args {
  postData: MaintenanceCreateTaskRequestDto;
}

export type MaintenanceTrackerTaskUserWebApiHandler_create_Options = UseMutationOptions<
  MaintenanceCreateTaskResponseDto,
  unknown,
  MaintenanceTrackerTaskUserWebApiHandler_create_Args
>;

/**
 * Create a maintenance task
 */
export const useMaintenanceTrackerTaskUserWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<MaintenanceTrackerTaskUserWebApiHandler_create_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: MaintenanceTrackerTaskUserWebApiHandler_create_Args) =>
      MaintenanceTrackerTaskUserWebApiHandler_create(args.postData, httpClient),
  });
};

export interface MaintenanceTrackerTaskUserWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type MaintenanceTrackerTaskUserWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  MaintenanceTrackerTaskUserWebApiHandler_delete_Args
>;

/**
 * Delete a maintenance task
 */
export const useMaintenanceTrackerTaskUserWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<MaintenanceTrackerTaskUserWebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: MaintenanceTrackerTaskUserWebApiHandler_delete_Args) =>
      MaintenanceTrackerTaskUserWebApiHandler_delete(args.getParams, httpClient),
  });
};

export type MaintenanceTrackerTaskUserWebApiHandler_details_Options = UseQueryOptions<
  MaintenanceTrackerTaskDetailsResponseDto,
  unknown,
  MaintenanceTrackerTaskDetailsResponseDto,
  readonly [string, DetailsParams]
>;

const MaintenanceTrackerTaskUserWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [MaintenanceTrackerTaskUserWebApiHandler_details_Path, getParams] as const;

export const MaintenanceTrackerTaskUserWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: MaintenanceTrackerTaskUserWebApiHandler_details_GetKey(getParams),
    queryFn: () => MaintenanceTrackerTaskUserWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get a maintenance task's details
 */
export const useMaintenanceTrackerTaskUserWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<MaintenanceTrackerTaskUserWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...MaintenanceTrackerTaskUserWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useMaintenanceTrackerTaskUserWebApiHandler_details.getKey = MaintenanceTrackerTaskUserWebApiHandler_details_GetKey;

export interface MaintenanceTrackerTaskUserWebApiHandler_update_Args {
  postData: MaintenanceUpdateTaskRequestDto;
}

export type MaintenanceTrackerTaskUserWebApiHandler_update_Options = UseMutationOptions<
  MaintenanceUpdateTaskResponseDto,
  unknown,
  MaintenanceTrackerTaskUserWebApiHandler_update_Args
>;

/**
 * Update a maintenance task
 */
export const useMaintenanceTrackerTaskUserWebApiHandler_update = ({
  httpClient,
  ...options
}: Omit<MaintenanceTrackerTaskUserWebApiHandler_update_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: MaintenanceTrackerTaskUserWebApiHandler_update_Args) =>
      MaintenanceTrackerTaskUserWebApiHandler_update(args.postData, httpClient),
  });
};

export interface MaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted_Args {
  getParams: UpdateDateCompletedParams;
}

export type MaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted_Options = UseMutationOptions<
  MaintenanceUpdateTaskResponseDto,
  unknown,
  MaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted_Args
>;

/**
 * Update a maintenance task's complete date
 */
export const useMaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted = ({
  httpClient,
  ...options
}: Omit<MaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: MaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted_Args) =>
      MaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted(args.getParams, httpClient),
  });
};

export interface MaintenanceTrackerTaskUserWebApiHandler_updateStatus_Args {
  getParams: UpdateStatusParams;
}

export type MaintenanceTrackerTaskUserWebApiHandler_updateStatus_Options = UseMutationOptions<
  MaintenanceUpdateTaskResponseDto,
  unknown,
  MaintenanceTrackerTaskUserWebApiHandler_updateStatus_Args
>;

/**
 * Update a maintenance task's status
 */
export const useMaintenanceTrackerTaskUserWebApiHandler_updateStatus = ({
  httpClient,
  ...options
}: Omit<MaintenanceTrackerTaskUserWebApiHandler_updateStatus_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: MaintenanceTrackerTaskUserWebApiHandler_updateStatus_Args) =>
      MaintenanceTrackerTaskUserWebApiHandler_updateStatus(args.getParams, httpClient),
  });
};
